var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "se-tab-buyer-console-fcl-container" } },
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEdit,
                    expression: "isEdit"
                  }
                ]
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "1",
                      type: "primary",
                      disabled: _vm.selectedContainerUsage === null
                    },
                    on: { click: _vm.changeSealHandler }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("SeaExport.SealNoChangeAdfterInspection")
                        ) +
                        " "
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "2", type: "primary" },
                    on: { click: _vm.autoLoadHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.AutoAllocation")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.autoLoadContractHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.AutoAllocationContract")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "3",
                      type: "primary",
                      disabled: _vm.selectedContainerUsage === null
                    },
                    on: { click: _vm.autoUnloadHandler }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("SeaExport.CleanOutTheLoadingRecord")) +
                        " "
                    )
                  ]
                ),
                !_vm.job.lclMasterUuid
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          no: "4",
                          type: "danger",
                          disabled: _vm.selectedContainerUsage === null
                        },
                        on: { click: _vm.deleteContainerHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.DeleteTheLoadingRecord")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isFCL
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "5", type: "primary" },
                        on: { click: _vm.downTemplateBtn_clickHandler }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("SeaExport.TemplateDownload")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "el-upload",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "padding-left": "5px"
                    },
                    attrs: {
                      action: "string",
                      "http-request": _vm.importExcelEventHandler,
                      "show-file-list": false,
                      accept: ".xls, .xlsx",
                      "before-upload": _vm.beforeUploadUsage
                    }
                  },
                  [
                    _vm.isFCL
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isEdit,
                                expression: "isEdit"
                              }
                            ],
                            attrs: { type: "primary" }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.ExcelImport")))]
                        )
                      : _vm._e(),
                    _vm.toExoSystemJYD && _vm.job.masterFlag
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !(
                                !_vm.jydEnable &&
                                !_vm.isEdit &&
                                _vm.job.jobState === 0
                              ),
                              no: "canPushPreConfiguration",
                              type: "primary"
                            },
                            on: { click: _vm.toCanPushPreConfiguration }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SystemMaintenance.canPushPreConfiguration"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", [
              _c(
                "span",
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("SeaExport.CargoQuantityDescription")) +
                      "：" +
                      _vm._s(_vm.lbTotalDesc.lblContainerDesc) +
                      " " +
                      _vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")) +
                      "：" +
                      _vm._s(_vm.lbTotalDesc.lbTotalQuantity) +
                      " " +
                      _vm._s(_vm.$t("SeaExport.TotalWeight")) +
                      "：" +
                      _vm._s(_vm.lbTotalDesc.lbTotalWeight) +
                      " " +
                      _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                      "：" +
                      _vm._s(_vm.lbTotalDesc.lbTotalCubage) +
                      " "
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.btnshowAWindow && !_vm.isEdit,
                          expression: "btnshowAWindow && !isEdit"
                        }
                      ],
                      staticClass: "can-operate",
                      attrs: { no: "6", type: "primary" },
                      on: { click: _vm.showAWindowClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ViewAssociatedBusiness")))]
                  )
                ],
                1
              )
            ])
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "config-module": "130115",
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.containerUsages,
              "wrap-text": true
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("seal-number-change-dialog", {
        attrs: {
          visible: _vm.boxNoDialog.visible,
          "prop-form-data": _vm.selectedContainerUsage
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.boxNoDialog, "visible", $event)
          },
          sealCloseHandler: _vm.sealCloseHandler
        }
      }),
      _c("associated-business-dialog", {
        attrs: {
          visible: _vm.associatedBusinessDialog.visible,
          "a-data": _vm.associatedBusinessDialog.aData,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.associatedBusinessDialog, "visible", $event)
          },
          refresh: _vm.refresh
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }